import {t} from '@lingui/core/macro';

export function getPortBatchModalHeader(actionValue?: string): string {
    switch (actionValue) {
        case 'start':
            return t`Массовое включение мониторов портов`;
        case 'stop':
            return t`Массовая остановка мониторов портов`;
        case 'edit':
            return t`Массовое изменение мониторов портов`;
        case 'delete':
            return t`Массовое удаление мониторов портов`;
        case 'tags':
            return t`Массовое добавление тегов`;
        case 'remove-by-target':
            return t`Удаление мониторов по списку адресов`;
        default:
            return t`Массовые операции`;
    }
}
